const INVOICE_TRANSLATIONS = {
  nl: 'Factuur',
  fr: 'Facture',
  de: 'Rechnung',
  it: 'Fattura',
  es: 'Factura',
  en: 'Invoice',
};

export const getInvoiceName = (invoiceNumber: string, language = navigator.language.split('-')[0]) => {
  const translation = INVOICE_TRANSLATIONS[language as keyof typeof INVOICE_TRANSLATIONS] || INVOICE_TRANSLATIONS['en'];
  return `${translation} ${invoiceNumber}`;
};

const CREDIT_NOTE_TRANSLATIONS = {
  nl: 'Creditnota',
  fr: 'Note de crédit',
  de: 'Gutschrift',
  it: 'Nota di credito',
  es: 'Abono',
  en: 'Credit note',
};

export const getCreditNoteName = (creditNoteNumber: string, language = navigator.language.split('-')[0]) => {
  const translation =
    CREDIT_NOTE_TRANSLATIONS[language as keyof typeof CREDIT_NOTE_TRANSLATIONS] || CREDIT_NOTE_TRANSLATIONS['en'];
  return `${translation} ${creditNoteNumber}`;
};
